import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FullScreenModal } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, TargetIcon, Typography } from 'procyon-ui'
import React from 'react'

const MsTeams = ({ showInfoModal, setShowInfoModal, handleIntegrationModalClick }) => {
  return (
    <FullScreenModal showModal={showInfoModal}>
      <div className='flex justify-center items-center h-[100%] bg-[#2229455a]'>
        <div className='w-[626px] rounded-lg p-8 bg-[var(--color-common-bg-base)]'>
          <div className='flex justify-between'>
            <Typography variant='h5' className='flex text-2xl items-center font-bold'>
              <TargetIcon
                width={'48px'}
                height={'48px'}
                type={'TEAMS'}
                className='rounded'
                style={{
                  borderRadius: '12px',
                  marginRight: '15px'
                }}
              />
              Microsoft Teams
            </Typography>
            <div className='flex gap-4'>
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'close', 'msteam')}
                id='close-button'
                onClick={() => setShowInfoModal(false)}
                variant='gray'
                icon={faClose}
                iconPosition='end'
              >
                Close
              </Button>
            </div>
          </div>
          <div className='p-4 mt-2 rounded text-black max-h-[60vh] overflow-auto'>
            <Typography variant='body-small' className='text-sm font-light'>
              Microsoft Teams (often referred to as MS Teams or simply Teams) is a collaboration
              platform developed by Microsoft as part of the Microsoft 365 suite of products.
            </Typography>

            <Typography variant='h5' className='font-regular mt-5 mb-2'>
              What is Microsoft Teams?
            </Typography>
            <Typography variant='body-small' className='font-light'>
              Microsoft Teams (MS Teams) is a collaboration platform developed by Microsoft, part of
              the Microsoft 365 suite. It combines workplace chat, video meetings, file storage, and
              application integration to facilitate seamless communication and collaboration within
              organizations. MS Teams allows users to create teams and channels for specific
              projects or departments, conduct virtual meetings, share and collaborate on documents
              in real-time, and integrate with various third-party apps and services. It's widely
              used for remote work, project management, and enhancing productivity through
              centralized communication.
            </Typography>
          </div>

          <div className='flex justify-end mt-4'>
            <Button
              data-testid={getHTMLDataTestID('integration', 'button', 'integrate', 'msteam')}
              size='md'
              onClick={() => handleIntegrationModalClick('msteam')}
              variant='primary'
            >
              Integrate
            </Button>
          </div>
        </div>
      </div>
    </FullScreenModal>
  )
}

export { MsTeams }
